import { render, staticRenderFns } from "./devservice.vue?vue&type=template&id=0c87e29b&scoped=true&"
import script from "./devservice.vue?vue&type=script&lang=js&"
export * from "./devservice.vue?vue&type=script&lang=js&"
import style0 from "./devservice.vue?vue&type=style&index=0&id=0c87e29b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c87e29b",
  null
  
)

export default component.exports